module.exports = __webpack_public_path__ + "img/scatter_freespin.f4e05a9b.png";